import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import {
  Box,
  Button,
  Card,
  CardHeader,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  MenuItem,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip
} from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getConfirmTypeForDynamic, updateConfirmTypeDynamic, addNewConfirmTypeDynamic } from 'src/store/slices/dynamicCatalogSlice';
import AlertAndLoading from 'src/components/AlertAndLoading';
import {
  ORANGE,
  darkButtonSx,
  dialogPaperProps,
  inputSx,
  lightButtonSx,
  listboxProps,
  useDynamicStyles
} from 'src/components/dynamicCatalogStyles';
import DynamicListToolbar from 'src/components/DynamicListToolbar';
import DynamicGroupList, { isTruthyFlag } from 'src/components/DynamicGroupList';

function ConfirmTypeDynamic() {
  const classes = useDynamicStyles();
  const dispatch = useDispatch();
  const [confirmType, setConfirmType] = React.useState([]);
  const [confirmTypeAddPopUp, setConfirmTypeAddPopUp] = React.useState(false);
  const [openKeys, setOpenKeys] = React.useState(new Set());
  const [loading, setLoading] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const [addOrUpdate, setAddOrUpdate] = React.useState(0);
  const [confirmTypeDsc, setConfirmTypeDsc] = React.useState('');
  const [confirmTypeDetailDsc, setConfirmTypeDetailDsc] = React.useState('');
  const [confirmTypeId, setConfirmTypeId] = React.useState('');
  const [confirmTypeDetailId, setConfirmTypeDetailId] = React.useState(null);
  const [ActiveOrPassive, setActiveOrPassive] = React.useState(1);
  const [searchText, setSearchText] = React.useState('');
  const [responseMessage, setresponseMessage] = React.useState('');
  const [uyari, setUyari] = React.useState(false);
  const [alertType, setAlertType] = React.useState({ ErrorType: 'error', ErrorTitle: 'Uyarı' });

  const loadConfirmTypes = () => {
    setLoading(true);
    dispatch(getConfirmTypeForDynamic())
      .then(response => {
        setLoading(false);
        if (Array.isArray(response.payload)) setConfirmType(response.payload);
      }).catch(() => { setLoading(false); });
  };

  useEffect(() => {
    loadConfirmTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  function InfoAlert(ErrorDescription, ErrorType, ErrorTitle) {
    setresponseMessage(ErrorDescription);
    setAlertType({
      ErrorType: ErrorType,
      ErrorTitle: ErrorTitle
    })
    setUyari(true);
    return
  }

  const toggleGroup = (key) => {
    setOpenKeys((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key); else next.add(key);
      return next;
    });
  };

  const allOpen = confirmType.length > 0 && confirmType.every((g) => openKeys.has(g.Id));

  // Yeni detay; gruptaki + ile açılırsa üst tür seçili gelir
  function handleAdd(group) {
    setAddOrUpdate(0);
    setConfirmTypeDsc('');
    setConfirmTypeDetailDsc('');
    setConfirmTypeId(group?.Id ?? '');
    setConfirmTypeDetailId(null);
    setActiveOrPassive(1);
    setConfirmTypeAddPopUp(true);
  }

  // Üst tür, detayın listelendiği gruptan alınır (detaydaki UST_DEGISIM_TURU combo değeriyle eşleşmiyordu)
  function RowClick(row, group) {
    setConfirmTypeDsc(row.UST_DEGISIM_ACIKLAMA ?? group?.Dsc);
    setConfirmTypeDetailDsc(row.ACIKLAMA);
    setConfirmTypeId(group?.Id ?? row.UST_DEGISIM_TURU);
    setConfirmTypeDetailId(row.DEGISIM_TURU);
    // Detayın mevcut aktiflik durumu ile açılır (önceden her zaman Aktif geliyordu)
    setActiveOrPassive(isTruthyFlag(row.Aktif) ? 1 : 0);
    setAddOrUpdate(1);
    setConfirmTypeAddPopUp(true);
  }

  function closePopUp() {
    if (saving) return;
    setConfirmTypeAddPopUp(false);
  }

  function UpdateOrAddClick() {
    if (!confirmTypeDetailDsc?.trim() || !confirmTypeId) {
      InfoAlert('Lütfen Kutucukları Boş Bırakmayınız!...', 'error', 'Hata');
      return;
    }
    const data = {
      ConfirmTypeDsc: confirmTypeDsc,
      ConfirmTypeDetailDsc: confirmTypeDetailDsc,
      Active: ActiveOrPassive,
      ConfirmTypeId: confirmTypeId,
      ConfirmTypeDetailId: confirmTypeDetailId || 0
    }
    setSaving(true);
    const request = addOrUpdate === 1
      ? dispatch(updateConfirmTypeDynamic(data))
      : dispatch(addNewConfirmTypeDynamic(data));
    request.then(response => {
      setSaving(false);
      if (response.payload?.ErrorCode && response.payload.ErrorCode !== '0') {
        InfoAlert(response.payload.ErrorDescription, 'error', 'Hata');
        return;
      }
      setConfirmTypeAddPopUp(false);
      setOpenKeys((prev) => new Set(prev).add(confirmTypeId));
      loadConfirmTypes();
    })
  }

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const detailCount = confirmType.reduce((sum, g) => sum + (g.Detail?.length || 0), 0);

  return (
    <>
      <AlertAndLoading Message={responseMessage} open={uyari} AlertType={alertType} onClose={uyariKapat} />
      <Card className={classes.card}>
        <CardHeader
          className={classes.cardHeader}
          title="Onay Türleri ve Detayları"
          subheader={loading ? 'Yükleniyor…' : `${confirmType.length} onay türü · ${detailCount} detay`}
          action={
            <Button startIcon={<AddIcon />} sx={darkButtonSx} onClick={() => handleAdd(null)}>
              Yeni Detay
            </Button>
          }
        />
        {loading && <LinearProgress sx={{ height: 2, '& .MuiLinearProgress-bar': { backgroundColor: ORANGE }, backgroundColor: '#ffe0b2' }} />}
        <DynamicListToolbar searchText={searchText} onSearchChange={setSearchText} placeholder="Onay türü veya detay ara">
          <Button
            size="small"
            sx={{ ...lightButtonSx, ml: 'auto' }}
            startIcon={allOpen ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
            onClick={() => setOpenKeys(allOpen ? new Set() : new Set(confirmType.map((g) => g.Id)))}
          >
            {allOpen ? 'Tümünü Kapat' : 'Tümünü Aç'}
          </Button>
        </DynamicListToolbar>
        <Box sx={{ maxHeight: 600, overflowY: 'auto' }}>
          <DynamicGroupList
            groups={confirmType}
            openKeys={openKeys}
            onToggle={toggleGroup}
            searchText={searchText}
            getGroupKey={(g) => g.Id}
            getGroupLabel={(g) => g.Dsc}
            isGroupActive={(g) => isTruthyFlag(g.Active)}
            getDetails={(g) => g.Detail}
            getDetailKey={(d) => d.DEGISIM_TURU}
            getDetailLabel={(d) => d.ACIKLAMA}
            isDetailActive={(d) => isTruthyFlag(d.Aktif)}
            onAddInGroup={handleAdd}
            addInGroupTooltip="Bu onay türüne detay ekle"
            emptyText={loading ? '' : 'Kayıtlı onay türü bulunamadı.'}
            renderDetailActions={(d, g) => (
              <Tooltip title="Düzenle">
                <IconButton size="small" onClick={() => RowClick(d, g)}>
                  <EditIcon sx={{ fontSize: 18, color: ORANGE }} />
                </IconButton>
              </Tooltip>
            )}
          />
        </Box>
      </Card>

      <Dialog open={confirmTypeAddPopUp} onClose={closePopUp} fullWidth maxWidth="sm" PaperProps={dialogPaperProps}>
        <DialogTitle className={classes.dialogTitle}>
          {addOrUpdate === 1 ? 'Onay Türü Detayı Düzenle' : 'Yeni Onay Türü Detayı'}
          <IconButton size="small" onClick={closePopUp} disabled={saving}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: '16px !important', opacity: saving ? 0.6 : 1, pointerEvents: saving ? 'none' : 'auto', transition: 'opacity 0.2s' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              size="small"
              fullWidth
              select
              label="Üst Onay Türü"
              sx={inputSx}
              value={confirmTypeId}
              disabled={addOrUpdate === 1}
              helperText={addOrUpdate === 1 ? 'Mevcut detayın üst onay türü değiştirilemez.' : ''}
              FormHelperTextProps={{ sx: { fontSize: '11px', mx: 0.5 } }}
              onChange={(e) => setConfirmTypeId(e.target.value)}
              SelectProps={{ MenuProps: { PaperProps: listboxProps } }}
            >
              {confirmType?.filter((a) => isTruthyFlag(a.Active) || a.Id === confirmTypeId).map((index) => (
                <MenuItem key={index.Id} value={index.Id} sx={{ fontSize: '13px' }}>
                  {index.Dsc}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              label="Onay Türü Detayı"
              value={confirmTypeDetailDsc}
              size="small"
              fullWidth
              sx={inputSx}
              onChange={(e) => setConfirmTypeDetailDsc(e.target.value)}
            />
            <Box className={classes.dialogSection}>
              <div className={classes.sectionLabel}>Durum</div>
              <ToggleButtonGroup
                exclusive
                size="small"
                className={classes.toggleGroup}
                value={ActiveOrPassive}
                onChange={(e, v) => v !== null && setActiveOrPassive(v)}
              >
                <ToggleButton value={1}>Aktif</ToggleButton>
                <ToggleButton value={0}>Pasif</ToggleButton>
              </ToggleButtonGroup>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button sx={lightButtonSx} onClick={closePopUp} disabled={saving}>Vazgeç</Button>
          <Button
            sx={{ ...darkButtonSx, minWidth: 110 }}
            onClick={UpdateOrAddClick}
            disabled={saving || !confirmTypeId || !confirmTypeDetailDsc?.trim()}
            startIcon={saving ? <CircularProgress size={14} sx={{ color: ORANGE }} /> : null}
          >
            {addOrUpdate === 1 ? 'Güncelle' : 'Ekle'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ConfirmTypeDynamic;
